import Vue from 'vue';
import Router from 'vue-router';
import Introduction from './views/introduction/index.vue';
import { auth } from '@/firebase/config.js';

import Login from './views/login/index.vue';

import Chapter from './views/chapter/index.vue';
import Subchapter from './views/content/index.vue';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'introduction',
      component: Introduction,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/capitulo/:chapterID',
      name: 'chapter',
      component: Chapter,
    },
    {
      path: '/capitulo/:chapterID/conteudo/:contentID',
      name: 'content',
      component: Subchapter,
    },
  ],
});

// Login check
router.beforeEach((to, from, next) => {
  const { currentUser } = auth;
  // Logs out if path is login
  if (to.path === '/login') {
    auth.signOut();
    next();
    // Check if user is logged in whenever they navigate
  } else if (to.path !== '/login' && !currentUser) {
    next('login');
  } else next();
});

export default router;
